<template>
  <div class="leave-page">
    <div>
      <h2 class="page-title"></h2>
      <template slot="title">
        <i class="i-Calendar-4  ul-tab__icon" />
      </template>
      <b-card-text>
        <div class="calendar">
          <LeaveCalendar :legend="legend" />
        </div>
      </b-card-text>
    </div>
  </div>
</template>

<script>
import LeaveCalendar from "@/components/leave/leaveCalendar"

import "@fullcalendar/core/main.css"
import "@fullcalendar/daygrid/main.css"
import "@/assets/styles/calendar/calendar_custom.css"

export default {
  components: {
    LeaveCalendar
  },
  data() {
    return {
      loading: true,
      blurredEvents: [],
      legend: {
        data: [
          // { value: 0, name: "Work From Home" },
          { value: 0, name: "Leave" },
          { value: 0, name: "Sick Leave" },
          { value: 0, name: "Study Leave" }
        ],
        // colours: ["#07dbd7", "#AD4FFC", "#FDD835", "#0277BD"]
        colours: ["#AD4FFC", "#FDD835", "#0277BD"]
      }
    }
  }
}
</script>

<style scoped>
.leave-page {
  margin-top: 30 !important;
}
</style>
